const SeparateFlower = () => {
  return (
    <svg className="separate-flower" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" width="2" height="2" rx="1" fill="#DFCFC8"/>
        <path d="M5 7C5 4.23858 7.23858 2 10 2C10 4.76142 7.76142 7 5 7Z" fill="#DFCFC8"/>
        <path d="M5 7C2.23858 7 -9.78513e-08 4.76142 -2.18557e-07 2C2.76142 2 5 4.23858 5 7Z" fill="#DFCFC8"/>
    </svg>
  )
}

export default SeparateFlower